export const EventPriceKind = {
  UNKNOWN: 'unknown',
  FREE: 'free',
  FIXED: 'fixed',
  RANGE: 'range',
} as const
export type EventPriceKind = (typeof EventPriceKind)[keyof typeof EventPriceKind]

export const TagType = {
  CATEGORY: 'category',
  SUB_CATEGORY: 'sub_category',
  SUB_SUB_CATEGORY: 'sub_sub_category',
  AMENITY: 'amenity',
} as const
export type TagType = (typeof TagType)[keyof typeof TagType]

/**
 * Root category tag names that stand for "all categories": the discovery shelves
 * and the search fallback when no category is selected both resolve this set, so
 * a shelf and the search behind it return the same items. Order drives the
 * discovery shelf order.
 */
export const DEFAULT_CATEGORIES = [
  'FoodAndDrinks',
  'CultureAndActivities',
  'ActionAndSports',
  'HealthAndFitness',
  'PartyAndClubbing',
] as const
export type DefaultCategory = (typeof DEFAULT_CATEGORIES)[number]
